import useSWR from 'swr';
import { useShallow } from 'zustand/react/shallow';

import { useUserProfile } from '@/states/user-profile';
import { ENDPOINTS } from '@/api/endpoints';
import { getSitesByClinic } from '@/api/sites';
import { getCameras } from '@/api/cameras';

export const useGetCatalogsCreateCase = () => {
  const profile = useUserProfile(useShallow((s) => s.profile));

  const {
    data: sites,
    isLoading: isLoadingSites,
    mutate: getSites,
  } = useSWR(
    [ENDPOINTS.SITES, profile.clinic],
    () => getSitesByClinic({ clinic_id: profile.clinic }),
    { revalidateOnFocus: false }
  );

  const {
    data: cams,
    isLoading: isLoadingCams,
    mutate: getCams,
  } = useSWR([ENDPOINTS.CAMERAS], () => getCameras(), {
    revalidateOnFocus: false,
  });

  const handleRefetch = () => {
    void getSites();
    void getCams();
  };

  return {
    catalogs: {
      sites: sites?.map((site) => ({
        [site.site_id]: site.description ?? site.site_id,
      })),
      cams,
    },
    loading: isLoadingSites || isLoadingCams,
    refetchCatalog: handleRefetch,
  };
};
